import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, Typography, Box } from '@mui/material'
import { CategoryStat } from '../../types/dashboard'

interface CategoryStatsProps {
  stats: CategoryStat[]
}

export const CategoryStats: React.FC<CategoryStatsProps> = ({ stats }) => {
  const { t } = useTranslation('dashboard')

  if (stats.length === 0) {
    return null
  }

  return (
    <Card sx={{ mt: 3 }}>
      <CardHeader title={t('categoryStats.title')} />
      <CardContent sx={{ pt: 0 }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
            gap: 2,
          }}
        >
          {stats.map((stat) => (
            <Box
              key={stat.category}
              p={2}
              border="1px solid #E5E7EB"
              borderRadius={1}
              textAlign="center"
            >
              <Typography variant="h6" gutterBottom>
                {stat.category}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {t('overview.totalTests')}: {stat.totalTests}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {t('overview.completionRate')}: {stat.completionRate}%
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {t('overview.averageScore')}: {stat.averageScore}
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  )
}
